import React, { forwardRef, useEffect, useRef, useState } from "react"
import {
  StyledPortionFormItem,
  PortionLabel,
  StyledPortionInput,
} from "./styled"
import { FlexBox } from "components/Common/FlexBox"
import DisplayedGramAndCaloriesPerUnit from "components/Common/DisplayedGramAndCaloriesPerUnit"
import PortionInput from "components/foodDetails/share/PortionInput"

type Ref = HTMLInputElement

export interface IUnitInputProps {
  value: string
  onChange: (value: string) => void
  isError?: boolean
  disabled?: boolean
  setIsPortionValid?: (isValid: boolean) => void
}

const UnitInputItem = forwardRef<Ref, IUnitInputProps>((props, ref) => {
  const { value, disabled = false, onChange, setIsPortionValid } = props

  const [localValue, setLocalValue] = useState(value)

  useEffect(() => {
    if (value !== localValue) {
      setLocalValue(value)
    }
  }, [value])

  const onUnitChange = (value: string) => {
    setLocalValue(value)
    onChange(value)

    if (!value) {
      setIsPortionValid?.(false)
    } else {
      setIsPortionValid?.(true)
    }
  }

  const onBlur = () => {
    if (localValue === "" || localValue === null) {
      setLocalValue("unit")
      onChange("unit")
      setIsPortionValid?.(true)
    }
  }

  return (
    <StyledPortionInput
      onBlur={onBlur}
      ref={ref}
      value={localValue}
      onChange={(e) => {
        if (!disabled) {
          onUnitChange(e.target.value)
        }
      }}
    />
  )
})

export interface IPortionFormItemProps {
  portionValue: number
  onPortionChange: (portion: number) => void

  unitValue: string
  onUnitChange: (unit: string) => void

  style?: React.CSSProperties
  disabled?: boolean
  setIsPortionValid?: (isValid: boolean) => void
  calories?: number
  gram: null | number
}

const PortionWithUnitTextField = (props: IPortionFormItemProps) => {
  const {
    onPortionChange,
    portionValue,
    unitValue,
    onUnitChange,
    style = {},
    disabled,
    setIsPortionValid,
    calories,
    gram,
  } = props

  const firstInputRef = useRef<HTMLInputElement>(null)
  const secondInputRef = useRef<HTMLInputElement>(null)

  return (
    <StyledPortionFormItem style={style}>
      <FlexBox
        $justify="space-between"
        $alignItems="center"
        $gap={12}
        style={{ width: "100%" }}
      >
        <PortionLabel>Portion</PortionLabel>

        <FlexBox $alignItems="center" $gap={12}>
          <PortionInput
            width={80}
            disabled={disabled}
            ref={firstInputRef}
            value={portionValue}
            onChange={onPortionChange}
            setIsPortionValid={setIsPortionValid}
          />

          <UnitInputItem
            disabled={disabled}
            ref={secondInputRef}
            value={unitValue}
            onChange={onUnitChange}
            setIsPortionValid={setIsPortionValid}
          />
        </FlexBox>
      </FlexBox>

      <DisplayedGramAndCaloriesPerUnit
        calories={calories}
        portion={portionValue}
        unit={unitValue}
        gram={gram}
        alwayDisplayGram
      />
    </StyledPortionFormItem>
  )
}

export default PortionWithUnitTextField
